module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w"
  }, [_c('y-shelf', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "title": "支付成功"
    }
  }, [_c('div', {
    staticClass: "content",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', [_c('i', {
    staticClass: "el-icon-circle-check icon-success"
  }), _vm._v(" 恭喜您支付成功\n      ")]), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/user"
    }
  }, [_c('y-button', {
    staticStyle: {
      "width": "150px",
      "height": "50px",
      "line-height": "48px",
      "font-size": "20px"
    },
    attrs: {
      "text": "查看订单",
      "classStyle": "main-btn"
    }
  })], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/goods"
    }
  }, [_c('y-button', {
    staticStyle: {
      "width": "150px",
      "height": "50px",
      "line-height": "48px",
      "font-size": "20px"
    },
    attrs: {
      "text": "继续选购",
      "classStyle": "main-btn"
    }
  })], 1)], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06e146a6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/paysuccess.vue
// module id = 739
// module chunks = 2